<template>
  <view class="price">
    <view v-if="price || price === 0" class="moneyLeft" :style="`color:${moneyColor};font-size:${fontSize}px`">
      <view class="money" v-if="price">
        <text :style="`font-size:${fontSize - 5}px`">￥</text>
        <span :style="`font-size:${fontSize}px`">{{ fen2yuan(price).split('.')[0] }}.</span>
        <span :style="`font-size:${fontSize - 4}px`">{{ fen2yuan(price).split('.')[1] }}</span>
      </view>
      <view class="money" v-else> 0 </view>
      <view v-if="range" class="info"> 起</view>
      <view class="info2" v-if="showlev == 3">
        折后价
        <!-- <img :src="iconBaseUrl + '/opmallh5/user/zhj.png'" class="cut_off" mode="aspectFit" /> -->
      </view>
      <view class="info2" v-if="showlev == 4">
        立减价
        <!-- <img :src="iconBaseUrl + '/opmallh5/user/ljj.png'" class="cut_off" mode="aspectFit"/> -->
      </view>
      <view class="info2" v-if="showlev == 5">
        秒杀价
        <!-- <img :src="iconBaseUrl + '/opmallh5/user/zhj.png'" class="cut_off" mode="aspectFit" /> -->
      </view>
    </view>
  </view>
</template>
<script>
import { fen2yuan } from "@/sheep/hooks/useGoods";
import sheep from '@/sheep';
const baseUrl = import.meta.env.SHOPRO_BASE_IMG_URL;

export default {
  name: "price",
  props: {
    priceImg: {
      type: Boolean,
      default: true
    },
    price: {
      type: [String, Number],
      default: ""
    },
    moneyColor: {
      type: String,
      default: '#fa052f'
    },
    fontSize: {
      type: [String, Number],
      default: '14'
    },
    ImgWidth: {
      type: [String, Number],
      default: '16'
    },
    range: {
      type: Boolean,
      default: false
    },
    showlev: {
      type: [String, Number],
      default: '1'
    }
  },
  computed: {

  },
  data() {
    return {
      level: 1,
      iconBaseUrl: baseUrl,

    };
  },
  methods: {
    fen2yuan
  },
  mounted() {
    const userInfo = JSON.parse(uni.getStorageSync('user-store')) || {}
    this.level = userInfo.userInfo.level.level
  }
};
</script>
<style lang="scss" scoped>
.price {
  height: 40rpx;
  display: flex;
  align-items: center;

  .moneyLeft {
    display: flex;
    align-items: center;
    font-size: 36rpx;
    font-weight: 600;

    img {
      margin-right: 8rpx;
      position: relative;
      top: -1px;
    }

    .money {
      font-family: Douyin;
      line-height: 38rpx;
      font-size: 32rpx;
    }

    .info {
      font-size: 24rpx;
      margin-left: 6rpx;
    }

    .info2 {
      color:#ff3620;
      transform: translateY(-4rpx);
      font-size: 22rpx;
      margin-left: 8rpx;
      font-weight:500;
    }

    .cut_off {
      width: 76rpx;
      transform: translateY(4rpx);
    }
  }

}
</style>
